import { useTotalRentCache } from '../../queries/useTotalRentCache';
import { ShowIf } from '../../../../../../../../components/ShowIf';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { singleStructures } from '../../../../../../constants/singleStructures';

interface UnitInformationFooterProps {
    propertyGuid: string;
    type: string;
    includeOccupied: boolean;
    isReview?: boolean;
}

export const UnitInformationFooter: React.FC<UnitInformationFooterProps> = ({
    propertyGuid,
    type,
    includeOccupied,
    isReview = false,
}) => {
    const totalRent = useTotalRentCache(propertyGuid);

    return (
        <>
            {!singleStructures.includes(type) &&
                (isReview ? (
                    <div className='unit-info-footer'>
                        <h4>
                            Total Rent : <span style={{ marginLeft: '40px' }}>{formatCurrencyOrUndefined(totalRent, 0)}</span>
                        </h4>
                    </div>
                ) : (
                    <div className='unit-info-footer'>
                        <div className='col unit'>
                            <h4>Total Rent :</h4>
                        </div>
                        <ShowIf showIf={includeOccupied}>
                            <div className='col'></div>
                        </ShowIf>
                        <div className='col'>
                            <h4 style={{ marginLeft: '20px' }}>{formatCurrencyOrUndefined(totalRent, 0)}</h4>
                        </div>
                        <div className='col'></div>
                        <div className='col'></div>
                        <div className='col'></div>
                        <div className='col'></div>
                    </div>
                ))}
        </>
    );
};
